import type { IconProps } from './../../models/icon';

export function InsuranceIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = ''
}: IconProps) {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            className={className}
        >
            <path 
                stroke="currentColor"
                strokeWidth="3.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M38 44.7142L44.9819 36.3357C46.0088 35.1034 46.5714 33.55 46.5714 31.9459V9.85697C46.5714 8.27915 45.2922 6.99995 43.7141 6.99995C40.5584 6.99995 38 9.55835 38 12.7142V28.071"
            />
            <path
                stroke="currentColor"
                strokeWidth="3.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M34.5714 34.4285L37.1429 31.8571C38.563 30.4369 38.563 28.1344 37.1429 26.7142C35.7228 25.2941 33.4201 25.2941 32 26.7142L28.0084 30.7058C26.7224 31.9918 26 33.7359 26 35.5546V44.7142"
            />
            <path
                stroke="currentColor"
                strokeWidth="3.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 44.7142L3.01806 36.3357C1.9912 35.1034 1.42857 33.55 1.42857 31.9459V9.85697C1.42857 8.27915 2.70777 6.99995 4.28594 6.99995C7.4416 6.99995 10 9.55835 10 12.7142V28.071"
            />
            <path
                stroke="currentColor"
                strokeWidth="3.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.4286 34.4285L10.8571 31.8571C9.43696 30.4369 9.43696 28.1344 10.8571 26.7142C12.2772 25.2941 14.5799 25.2941 16 26.7142L19.9916 30.7058C21.2776 31.9918 22 33.7359 22 35.5546V44.7142"
            />
            <path
                fill={secondaryColor}
                stroke="currentColor"
                strokeWidth="3.43"
                strokeLinejoin="round"
                d="M34 10.2973C29.4054 7.86486 26.7027 6.24324 24 3C21.2973 6.24324 19.1351 7.86486 14 10.2973C16.1622 17.3243 19.1351 21.3784 24 25.7027C28.8649 21.3784 31.8378 17.3243 34 10.2973Z"
            />
      
    </svg>
    );
}
